<template>
    <div :class="editMode ? 'p-3' : ''">
        <div class="d-flex justify-content-end flex-wrap mb-3" v-if="!editMode">
            <button
                v-if="detailedItem.order_id"
                type="button"
                class="btn btn-outline-green ml-1"
                @click="openOrderSidebar(detailedItem.order_id)"
            >
                В заказ
            </button>
            <button
                v-if="detailedItem.service && detailedItem.service.reference_service_id"
                type="button"
                class="btn btn-outline-green ml-1"
                @click="openOrderSidebar(detailedItem.order_id, '', {tab: detailedItem.service.reference_service_id})"
            >
                В услугу
            </button>
        </div>

        <div class="row active-panel-block align-items-center m-0">
            <div class="active-panel-block_icon">
                <b-icon icon="grip-vertical" font-scale="2" class="text-secondary"></b-icon>
            </div>
            <div class="active-panel-block_one">
                <span class="text-bold-size-13 text-secondary">
                    <i class="fas fa-user-circle text-orange mr-1"></i> Менеджер:
                    <span class="font-weight-light">{{ detailedItem.creator.name || "Не известно" }}</span>
                </span>
            </div>
            <div class="text-bold-size-13 active-panel-block_two text-secondary">
                <span class="font-weight-bold text-uppercase"><i class="fas fa-info-circle text-orange mr-1"></i> Статус:</span>
                <span class="font-weight-light text-uppercase mr-2">
                    {{ debtInRubles() <= 0 && detailedItem.sum != 0 ? 'Оплачено' : 'Ожидает оплаты' }}
                </span>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-12">
                <b-overlay
                    :show="dataOverlay"
                    spinner-variant="success"
                    no-wrap
                />
                <table class="table table-hover table-borderless table-fixed">
                    <tbody>
                        <tr>
                            <td class="table-title-details">Номер счета</td>
                            <td>
                                <template v-if="!editMode">
                                    {{ detailedItem.invoice_number || "Не задан" }}
                                </template>
                                <template v-if="editMode">
                                    <b-form-input 
                                        size="sm" 
                                        v-model.trim="detailedItem.invoice_number"
                                        type="text" class="form-control"
                                        id="invoice_number"
                                        />
                                    </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Номер заказа</td>
                            <td>
                                <span
                                    v-if="detailedItem.order_id"
                                    class="font-weight-bold sidebar-link text-primary"
                                    title="Открыть заказ"
                                    @click="openOrderSidebar(detailedItem.order_id)"
                                >
                                    #{{ detailedItem.order_id }}
                                </span>
                                <template v-else>Не привязан</template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Дата счета</td>
                            <td>{{ (detailedItem.invoice_datetime || "Не указана") | formattedDate }}</td>
                        </tr>
                        <tr>
                            <td class="table-title-details">{{ dateRealizationBlock.blockName }}</td>
                            <td>
                                <div class="align-items-center d-flex justify-content-between">
                                    <div>{{ (detailedItem.realization_datetime || "Не указана") | formattedDate }}</div>
                                    <div class="d-flex" v-if="canEdit && editMode">
                                        <template>
<!--                                        If not IP BORODINA-->
                                            <div v-if="detailedItem.company_id != 2 && !detailedItem.realization_datetime && checkRealizationDateAutoAbility() != -1">
                                                <span class="btn btn-outline-secondary ml-3" @click="addRealizationDateAuto">
                                                    <i class="fas fa-check mr-1"></i> Авто дата
                                                </span>
                                            </div>
                                            <div>
                                                <span class="btn btn-outline-secondary ml-3" @click="addRealizationDate">
                                                    <template v-if="detailedItem.realization_datetime">
                                                        <i class="fas fa-plus mr-1"></i> Изменить дату {{ dateRealizationBlock.changeDate }}
                                                    </template>
                                                    <template v-else>
                                                        <i class="fas fa-plus mr-1"></i> Добавить дату {{ dateRealizationBlock.changeDate }}
                                                    </template>
                                                </span>
                                            </div>
                                            <div v-if="detailedItem.realization_datetime">
                                                <span class="btn btn-outline-secondary ml-3" @click="clearRealizationDate" title="Очистить дату">
                                                    <i class="fas fa-trash"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="table-title-details">Предоставлены</td>
                            <td>
                                <div class="align-items-center d-flex justify-content-between">
                                    <template v-if="detailedItem.finance_substatuses.length > 0">
                                        <div class="table-mini-info-details shadow-orange">
                                            <div
                                                v-for="(substatus, index) in detailedItem.finance_substatuses"
                                                :key="index"
                                                class="d-flex justify-content-between align-items-center my-2"
                                            >
                                                <div>
                                                    {{ substatus.substatus_local }}
                                                </div>
                                                <div>
                                                    <b-icon
                                                        icon="x"
                                                        scale="1.7"
                                                        variant="danger"
                                                        class="float-right cursor-pointer"
                                                        title="Отменить статус"
                                                        v-if="canEdit && editMode"
                                                        @click="financeSubstatusDelete(substatus.id, index)"
                                                    ></b-icon>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        Не отмечалось
                                    </template>

                                    <template v-if="canEdit && editMode">
                                        <div class="d-flex">
                                            <div>
                                                <span
                                                    v-if="!isSubstatus(393)"
                                                    class="btn btn-outline-secondary ml-3"
                                                    @click="financeSubstatusCreate(393)"
                                                ><i class="fas fa-check mr-1"></i> Счет
                                                </span>
                                            </div>
                                            <div>
                                                <span
                                                    v-if="!isSubstatus(394)"
                                                    class="btn btn-outline-secondary ml-3"
                                                    @click="financeSubstatusCreate(394)"
                                                ><i class="fas fa-check mr-1"></i> Комплект</span>
                                            </div>
                                            <div>
                                                <span
                                                    v-if="!isSubstatus(399)"
                                                    class="btn btn-outline-secondary ml-3"
                                                    @click="financeSubstatusCreate(399)"
                                                ><i class="fas fa-check mr-1"></i> Оригинал</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Тип счета</td>
                            <td>{{ detailedItem.invoice_type_name || "Не известно" }}</td>
                        </tr>
                        <tr v-if="detailedItem.invoice_type == 'incoming'">
                            <td class="table-title-details">Плательщик</td>
                            <td>
                                <template v-if="detailedItem.order && detailedItem.order.company">
                                    <span
                                        class="sidebar-link"
                                        @click="openCompanySidebar(detailedItem.order.company.id)"
                                    >
                                        {{ detailedItem.order.company.name }}
                                    </span>
                                    /
                                    <span>
                                        {{ detailedItem.order.company.inn || "ИНН пока не задан" }}
                                    </span>
                                </template>
                                <template v-else-if="detailedItem.payer_company_id">
                                    <span
                                        class="sidebar-link"
                                        @click="openCompanySidebar(detailedItem.payer_company.id)"
                                    >
                                        {{ detailedItem.payer_company.name }}
                                    </span>
                                </template>
                                <template v-else>
                                    <span>Не задана</span>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="detailedItem.invoice_type == 'outgoing'">
                            <td class="table-title-details">Плательщик</td>
                            <td>
                                <template v-if="detailedItem.payer_company_id">
                                    <span
                                        class="sidebar-link"
                                        @click="openCompanySidebar(detailedItem.payer_company.id)"
                                    >
                                        {{ detailedItem.payer_company.name }}
                                    </span>
                                </template>
                                <template v-else>
                                    <span
                                        class="sidebar-link"
                                        @click="openCompanySidebar(1)"
                                    >
                                        АО "ТАНАИС"
                                    </span>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Получатель</td>
                            <td>
                                <span
                                    v-if="detailedItem.company"
                                    class="sidebar-link"
                                    @click="openCompanySidebar(detailedItem.company.id)"
                                >
                                    {{ detailedItem.company.name }}
                                </span>
                                <span v-else>Не задана</span>
                                /
                                <span>
                                    {{ detailedItem.company.inn || "ИНН пока не задан" }}
                                </span>
                            </td>
                        </tr>
                        <template v-if="detailedItem.unit === 'B2B'">
                            <tr v-if="detailedItem.service">
                                <td class="table-title-details">Услуга</td>
                                <td>{{ detailedItem.service.reference.name || "Не указана" }}</td>
                            </tr>
                            <tr v-else>
                                <td class="table-title-details">Услуга</td>
                                <td>Не указана</td>
                            </tr>
                        </template>
                        <tr v-if="serviceProperties['247']">
                            <td class="table-title-details">Место прибытия СВХ</td>
                            <td>{{ serviceProperties['247'] }}</td>
                        </tr>
                        <tr v-if="serviceProperties['248']">
                            <td class="table-title-details">Таможенный пост</td>
                            <td>{{ serviceProperties['248'] }}</td>
                        </tr>
                        <tr v-if="detailedItem.services_list.data && detailedItem.services_list.data.length > 0">
                            <td class="table-title-details">Перечень услуг</td>
                            <td>
                                <template v-if="detailedItem.unit === 'B2C'">
                                    <B2CServicesListDetails
                                        :servicesList="detailedItem.services_list.data"
                                    />
                                </template>
                                <template v-else>
                                    <div class="table-mini-info-details shadow-orange">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>№</th>
                                                    <th>Услуга</th>
                                                    <th class="text-center">Кол-во</th>
                                                    <th class="text-center">Цена</th>
                                                    <th class="text-center">Стоимость</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(service, index) in detailedItem.services_list.data" :key="index">
                                                    <td>{{ service.id }}</td>
                                                    <td>{{ service.name }}</td>
                                                    <td class="text-center">{{ service.number ? service.number : 1 }}</td>
                                                    <td class="text-center">{{ service.sum }}</td>
                                                    <td class="text-center">{{ (Number(service.number ? service.number : 1) * service.sum) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="detailedItem.invoice_type == 'outgoing'">
                            <td class="table-title-details">Тип услуги контрагентов</td>
                            <td>
                                <template v-if="detailedItem.service_for_partner">{{ detailedItem.service_for_partner.name || "Не указана" }}</template>
                                <template v-else>Не указана</template>
                            </td>
                        </tr>
                        <tr v-if='detailedItem.invoice_type == "incoming" && detailedItem.turning != null'>
                            <td class="table-title-details">Перевыставление, %</td>
                            <td>
                                <b>{{ detailedItem.turning }} %</b><br>
                                <small>
                                    {{ countTurningSum() }}
                                </small>
                            </td>
                        </tr>
                        <template v-if="detailedItem.unit === 'B2C'">
                            <tr v-if="detailedItem.reference_terminal">
                                <td class="table-title-details">Терминал</td>
                                <td>{{ detailedItem.reference_terminal.name || "Не указан" }}</td>
                            </tr>
                            <tr v-else>
                                <td class="table-title-details">Терминал</td>
                                <td>Не указана</td>
                            </tr>
                            <tr v-if="detailedItem.reference_expenses_category">
                                <td class="table-title-details">Категория расходов</td>
                                <td>{{ detailedItem.reference_expenses_category.name || "Не указана" }}</td>
                            </tr>
                            <tr v-else>
                                <td class="table-title-details">Категория расходов</td>
                                <td>Не указана</td>
                            </tr>
                        </template>
                        <tr>
                            <td class="table-title-details">Валюта</td>
                            <td>{{ detailedItem.currency_local.name || "Не указана" }}</td>
                        </tr>
                        <tr v-if="detailedItem.reference_currency_id != 122">
                            <td class="table-title-details">Сумма в валюте</td>
                            <td>
                                <b>{{ (detailedItem.sum_currency || 0) | toCurrency }} {{ detailedItem.currency_local.name }}</b>
                                <span class="text-danger" v-if="detailedItem.sum <= 0"> (Не забудьте указать сумму в рублях!)</span>
                            </td>
                        </tr>
                        <tr v-if="detailedItem.reference_currency_id != 122">
                            <td class="table-title-details">Оплачено в валюте</td>
                            <td><b>{{ (additionalData.paidSumCurrency || 0) | toCurrency }} {{ detailedItem.currency_local.name }}</b></td>
                        </tr>
                        <tr v-if="detailedItem.reference_currency_id != 122">
                            <td class="table-title-details">Задолженность в валюте</td>
                            <td><b :class="checkDbt()">{{ debtInCurrency() | toCurrency }} {{ detailedItem.currency_local.name }}</b></td>
                        </tr>
                        <!-- v-if="detailedItem.reference_currency_id != 122" //  при валютных платежах-->
                        <tr>
                            <td class="table-title-details">Комиссия банка</td>
                            <td>
                                <template v-if="!editMode">
                                    <b>{{ (detailedItem.commission_bank || 0) | toCurrency }} р.</b>
                                    <span class="text-danger" v-if="detailedItem.sum_payment > 0 && !detailedItem.commission_bank"> (Не забудьте указать комиссию банка в рублях!)</span>
                                </template>
                                <template v-if="editMode">
                                    <b-form-input
                                        size="sm"
                                        v-model.trim="detailedItem.commission_bank"
                                        type="text"
                                        class="form-control"
                                        id="commission_bank"
                                        @keyup="changeCommasOnDots($event)"
                                    ></b-form-input>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="detailedItem.reference_currency_id != 122">
                            <td class="table-title-details">Суммовая разница</td>
                            <td>
                                <template v-if="!editMode">
                                    <b :class="checkSumDiff()">{{ (detailedItem.sum_difference || 0) | toCurrency }} р.</b>
                                </template>
                                <template v-if="editMode">
                                    <b-form-input
                                        size="sm"
                                        v-model.trim="detailedItem.sum_difference"
                                        type="text"
                                        class="form-control"
                                        id="sum_difference"
                                        @keyup="changeCommasOnDots($event)"
                                    ></b-form-input>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Сумма в рублях</td>
                            <td>
                                <template v-if="!editMode || detailedItem.reference_currency_id == 122">
                                    <b>{{ (detailedItem.sum || 0) | toCurrency }} р.</b>
                                </template>
                                <template v-if="editMode && detailedItem.reference_currency_id != 122">
                                    <b-form-input
                                        size="sm"
                                        v-model.trim="detailedItem.sum"
                                        type="text"
                                        class="form-control"
                                        id="sum"
                                        @keyup="changeCommasOnDots($event)"
                                    ></b-form-input>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Натуральная форма?</td>
                            <td><b>{{ detailedItem.natural_text || "Не указана" }}</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Нулевая ставка</td>
                            <td><b>{{ detailedItem.zero_rate_text || "Не указана" }}</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">С НДС?</td>
                            <td><b>{{ detailedItem.with_nds_text || "Не указана" }}</b></td>
                        </tr>
                        <tr v-if="detailedItem.size_nds && detailedItem.size_nds > 0">
                            <td class="table-title-details">Размер НДС</td>
                            <td><b>{{ detailedItem.size_nds }}%</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Дата финальной оплаты</td>
                            <td>{{ (detailedItem.payment_datetime || "Не указана") | formattedDate }}</td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Оплачено в рублях</td>
                            <td><b>{{ (detailedItem.sum_payment || 0) | toCurrency  }} р.</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Задолженность в рублях</td>
                            <td><b :class="checkDbt()">{{ debtInRubles() | toCurrency }} р.</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        API_FINANCE,
        API_GET_ORDERS_SERVICES_PROPERTIES_LIST,
        API_POST_FINANCE_SUBSTATUS_CREATE,
        API_DELETE_FINANCE_SUBSTATUS_DELETE
    } from "@/constants";

    import {
        defaultDataItems,
        changeCommasOnDots
    } from '@/mixins';
    import { openCompanySidebar } from '@/mixins/openCompanySidebar';
    import { openOrderSidebar } from '@/mixins/openOrderSidebar';

    import B2CServicesListDetails from '@/components/finance/serviceLists/B2CServicesListDetails.vue';

    export default {
        props: {
            detailedItem: { type: Object, required: true },
            additionalData: { type: Object, required: false },
            editMode: {type: Boolean, required: true},
            canEdit: {type: Boolean, required: true},
            saveChanges: {type: Boolean, default: false},
        },
        components: {
            B2CServicesListDetails
        },
        mixins: [
            defaultDataItems,
            changeCommasOnDots,
            openCompanySidebar,
            openOrderSidebar
        ],
        data() {
            return {
                dataOverlay: false,
                serviceProperties: {
                    '247': '',          // СВХ
                    '248': '',          // Таможенный пост
                }
            }
        },
        watch: {
            saveChanges() {
                if (this.saveChanges) {
                    this.onSaveChanges();
                }
            }
        },
        computed: {
            dateRealizationBlock() {
                if (this.detailedItem.invoice_type == "outgoing") {
                    return {
                        blockName: "Дата акта",
                        changeDate: "акта"
                    }
                }

                return {
                    blockName: "Дата реализации (по Акту)",
                    changeDate: "реализации"
                }
            }
        },
        mounted() {
            if (this.detailedItem.service) {
                this.loadServiceProperties(this.detailedItem.service.id, '247,248') // СВХ и Таможенный пост
            }
        },
        methods: {
            onSaveChanges() {
                this.dataOverlay = true;
                api.call('put', `${API_FINANCE}/${this.detailedItem.id}`, this.detailedItem)
                    .then(({data}) => {
                        Object.assign(this.detailedItem, data);
                        this.$router.push({
                            query: {
                            ...this.$route.query,
                            'edit-finance': false,
                            },
                        });
                        this.dataOverlay = false;
                        this.$emit('updateParentData');
                        this.makeToast('success', 'Изменения счета сохранены');
                })
            },
            debtInCurrency() {
                return (this.detailedItem.sum_currency - this.additionalData.paidSumCurrency) || 0
            },
            debtInRubles() {
                if (this.detailedItem.reference_currency_id == 122 || this.debtInCurrency() !== 0) {
                    return this.detailedItem.sum - this.detailedItem.sum_payment - this.detailedItem.sum_difference;
                }
                return 0
            },
            checkDbt() {
                if (this.debtInRubles() > 0) {
                    return "text-danger"
                }
                return "text-success"
            },
            checkSumDiff() {
                if (this.detailedItem.sum_difference < 0) {
                    return "text-danger"
                }
                return "text-success"
            },
            addRealizationDate() {
                this.dataOverlay = true

                this.$swal.fire({
                    title: this.detailedItem.invoice_type == "outgoing" ? 'Укажите дату акта' : 'Укажите дату реализации по акту',
                    html:'<input type="date" id="popup_realization_datetime" class="form-control" autofocus>',
                    showCancelButton: true,
                    cancelButtonText: 'Отмена',
                    confirmButtonText: 'Сохранить',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        this.detailedItem.realization_datetime = document.getElementById("popup_realization_datetime").value;
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                }).then((result) => {
                    this.dataOverlay = false;
                })
            },
            checkRealizationDateAutoAbility() {
                let temp_finance_date_array = this.detailedItem.invoice_number ? this.detailedItem.invoice_number.split('/') : []
                if (temp_finance_date_array.hasOwnProperty(2)) {
                    let finance_date_array = temp_finance_date_array[2].split('')
                    if (finance_date_array.length == 4) {
                        let correct_year = this.$moment(this.detailedItem.invoice_datetime).format('YYYY')
                        let finance_realization_date = correct_year +
                            '-' + finance_date_array[0] + finance_date_array[1] +
                            '-' + finance_date_array[2] + finance_date_array[3] +
                            ' 00:00:00'

                        return finance_realization_date
                    }
                }
                return -1
            },
            addRealizationDateAuto() {
                let finance_realization_date = this.checkRealizationDateAutoAbility()

                if (finance_realization_date != -1) {
                    this.detailedItem.realization_datetime = finance_realization_date
                }
            },
            clearRealizationDate() {
                this.dataOverlay = true;
                this.detailedItem.realization_datetime = null;
                this.dataOverlay = false;
            },
            loadServiceProperties(order_service_id, reference_service_property_ids) {
                this.dataOverlay = true
                api.call("get", `${API_GET_ORDERS_SERVICES_PROPERTIES_LIST}/?order_service_id=${order_service_id}&reference_service_property_ids=${reference_service_property_ids}`)
                    .then(({data}) => {
                        data.forEach((property, index) => {
                            let text = this.$store.state.referencePropertiesList.list[property.value] ? this.$store.state.referencePropertiesList.list[property.value].text : ''
                            this.serviceProperties[property.reference_service_property_id] = text
                        })
                        this.dataOverlay = false
                    })
            },
            isSubstatus(reference_substatus_id) {
                let result = false;
                this.detailedItem.finance_substatuses.forEach((substatus) => {
                    if (reference_substatus_id == substatus.reference_substatus_id) {
                        result = true
                    }
                })
                return result
            },
            checkSubstatuses(finance_substatuses) {
                let result = [];
                finance_substatuses.forEach((substatus) => {
                    result.push(substatus.substatus_local)
                })
                result.sort();
                return result;
            },
            financeSubstatusCreate(reference_substatus_id) {
                let finance_id = this.detailedItem.id
                this.dataOverlay = true
                api.call("post", `${API_POST_FINANCE_SUBSTATUS_CREATE}/${finance_id}/${reference_substatus_id}`)
                    .then(({data}) => {
                        this.detailedItem.finance_substatuses.push(data);
                        this.dataOverlay = false;
                    })
            },
            financeSubstatusDelete(reference_substatus_id, index) {
                this.dataOverlay = true
                api.call("delete", `${API_DELETE_FINANCE_SUBSTATUS_DELETE}/${reference_substatus_id}`)
                    .then(({data}) => {
                        this.detailedItem.finance_substatuses.splice(index, 1);
                        this.dataOverlay = false;
                    })
            },
            countTurningSum() {
                let itogSum = 0;
                let valuteName = 'р.';

                if (this.detailedItem.sum_currency) {
                    itogSum = this.detailedItem.sum_currency * this.detailedItem.turning / 100;
                    valuteName = '$';
                    if (this.detailedItem.reference_currency_id == 123) valuteName = '€';
                    if (this.detailedItem.reference_currency_id == 378) valuteName = '￥';
                    if (this.detailedItem.reference_currency_id == 591) valuteName = '₺';
                    if (this.detailedItem.reference_currency_id == 906) valuteName = '֏';
                    if (this.detailedItem.reference_currency_id == 908) valuteName = 'د.إ';
                } else {
                    itogSum = this.detailedItem.sum * this.detailedItem.turning / 100;
                }
                return `Вознаграждение ${itogSum.toFixed(2)} ${valuteName}`;
            },
        }
    }
</script>
